import React, {useEffect, useState} from 'react'
import { withStyles, Typography } from '@material-ui/core';
import PropTypes from 'prop-types';
import GridBlock from 'components/GridBlock';
import TextInput from 'components/TextInput';
import Tr from 'translations/Translations';
import ErrorText from 'components/ErrorText';
import MeasureUnitService from 'services/MeasureUnitService';
import WorkableIconDeleteButton from 'components/button/WorkableIconDeleteButton';
import INPUT_TYPE from "constants/INPUT_TYPE";
import getObjectValue from "libs/getObjectValue";

const style = theme => ({
	root: {
		'&>*:last-child': {
			flexGrow: 1,
			textAlign: 'right'
		}
	},
	input: {
		width: theme.components.input.criteria.width,
		marginLeft: theme.spacing(1),
		marginRight: theme.spacing(1),
	},
	inputkey: {
		width: theme.components.input.criteriaKey.width,
		marginLeft: theme.spacing(1),
		marginRight: theme.spacing(1),
	},
});

function CriteriaElement({
	classes,
	index,
	formikProps,
	onDelete,
	disabled
}) {
	const id = 'valuesList';
	const [measureUnits, setMeasureUnits] = useState(null);
	const editable = getObjectValue('_editable', formikProps.values, false);

	useEffect(() => {
		MeasureUnitService.getRequired().then((resp) => setMeasureUnits(resp));
	}, []);

	const unitId = formikProps.values.uom;
	const unitLabel = unitId && measureUnits ? measureUnits.filter(mu => mu.value === unitId).label : '';

	const unitsId = `${id}.${index}.key`;
	const pointsId = `${id}.${index}.value`;
	return (
		<ErrorText idList={[unitsId, pointsId]} formikProps={formikProps}>
			<GridBlock className={classes.root} alignItems='center' >
				<Typography variant='body1'>
					{index + 1}. {Tr('add_criterium_e_eq')}
				</Typography>
				<TextInput className={classes.inputkey} noError id={unitsId} formikProps={formikProps} disabled={disabled} />
				<Typography variant='body1'>
					{unitLabel} {Tr('admit')}
				</Typography>
				<TextInput
					className={classes.input}
					noError
					id={pointsId}
					formikProps={formikProps}
					type={INPUT_TYPE.NUMBER_19}
					disabled={disabled}
				/>
				<Typography variant='body1'>
					{Tr('points')}.
				</Typography>
				<WorkableIconDeleteButton onClick={onDelete} disabled={!editable || disabled}/>
			</GridBlock>
		</ErrorText>
	)
}

CriteriaElement.propTypes = {
	classes: PropTypes.any,
	onDelete: PropTypes.func,
};

CriteriaElement.defaultProps = {
};

export default withStyles(style)(CriteriaElement);